import { render, staticRenderFns } from "./fotter.vue?vue&type=template&id=99a3ef20&scoped=true&"
import script from "./fotter.vue?vue&type=script&lang=js&"
export * from "./fotter.vue?vue&type=script&lang=js&"
import style0 from "./fotter.vue?vue&type=style&index=0&id=99a3ef20&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99a3ef20",
  null
  
)

export default component.exports